import React from "react";
import { Box } from "@mui/material";
import { SECTION_SPACING } from "../../constants/layout";

/**
 * Секція контенту з опційним картковим стилем (тінь, рамка, фон).
 * Для однакового вигляду блоків на головній та інших сторінках.
 */
const PageSection = ({
  children,
  card = false,
  spacing = SECTION_SPACING,
  sx = {},
  ...rest
}) => {
  return (
    <Box
      sx={{
        width: "100%",
        maxWidth: "100%",
        py: spacing,
        ...(card && {
          backgroundColor: "background.paper",
          borderRadius: 3,
          border: "1px solid",
          borderColor: "divider",
          boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
          px: { xs: 2, sm: 3, md: 4 },
        }),
        ...sx,
      }}
      {...rest}
    >
      {children}
    </Box>
  );
};

export default PageSection;
